import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetPredictiveMaintenanceScheduleResData } from "./GetPredictiveMaintenanceScheduleResData";

const ENDPOINT = "/predictive_maintenance/schedule";

export class GetPredictiveMaintenanceScheduleCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetPredictiveMaintenanceScheduleResData> {
        var res = await this.executeCommand();
        return new GetPredictiveMaintenanceScheduleResData(res);
    }
}
